var defaultConstants = {
    CURSOR_HEIGHT: 0,
    CURSOR_WIDTH: 0,
    ELEMENT_OFFSET_Y: 0,
    ELEMENT_OFFSET_X: 0,
};
var CLIENT_OFFSET = 10;
var getPositionOnViewport = function (element, cursorPosition, constants) {
    if (constants === void 0) { constants = defaultConstants; }
    var elementHeight = element.offsetHeight;
    var elementWidth = element.offsetWidth;
    var clientHeight = document.body.clientHeight - CLIENT_OFFSET;
    var clientWidth = document.body.clientWidth - CLIENT_OFFSET;
    var fitsTop = cursorPosition.top - elementHeight - constants.ELEMENT_OFFSET_Y >= 0;
    var fitsBottom = cursorPosition.top + constants.ELEMENT_OFFSET_Y + constants.CURSOR_HEIGHT + elementHeight <= clientHeight;
    var top;
    var left;
    if (fitsTop || fitsBottom) {
        if (!fitsBottom) {
            top = cursorPosition.top - elementHeight - constants.ELEMENT_OFFSET_Y;
        }
        else {
            top = cursorPosition.top + constants.ELEMENT_OFFSET_Y + constants.CURSOR_HEIGHT;
        }
        var fitsRight = cursorPosition.left + constants.ELEMENT_OFFSET_X + constants.CURSOR_WIDTH / 2 + elementWidth <= clientWidth;
        if (!fitsRight) {
            left = cursorPosition.left - elementWidth - constants.ELEMENT_OFFSET_X;
        }
        else {
            left = cursorPosition.left + constants.ELEMENT_OFFSET_X + constants.CURSOR_WIDTH / 2;
        }
    }
    else {
        var fitsRight = cursorPosition.left + constants.ELEMENT_OFFSET_X + constants.CURSOR_WIDTH + elementWidth <= clientWidth;
        top = cursorPosition.top - elementHeight / 2 + constants.CURSOR_HEIGHT / 2;
        if (!fitsRight) {
            left = cursorPosition.left - elementWidth - constants.ELEMENT_OFFSET_X;
        }
        else {
            left = cursorPosition.left + constants.ELEMENT_OFFSET_X + constants.CURSOR_WIDTH;
        }
    }
    return {
        left: left,
        top: top,
    };
};

export { CLIENT_OFFSET, getPositionOnViewport };
//# sourceMappingURL=position.js.map
